import { render, staticRenderFns } from "./UpdateProcess.vue?vue&type=template&id=56974878"
import script from "./UpdateProcess.vue?vue&type=script&lang=js"
export * from "./UpdateProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports